(function () {
  var MOBILE_QUERY = window.matchMedia('(max-width: 798px)');

  function initProductRitualStickyAtc() {
    var formBlock = document.querySelector('.product-ritual-mobile-zone--form');
    var stickyBar = document.getElementById('product-ritual-sticky-atc');
    var stickyButton = document.querySelector('[data-product-ritual-sticky-atc]');
    var mainButton = document.querySelector('.product-ritual-mobile-zone--form .add_to_cart');

    if (!formBlock || !stickyBar || !stickyButton || !mainButton) {
      return;
    }

    function setStickyVisible(isVisible) {
      stickyBar.hidden = !isVisible;
      stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      stickyBar.classList.toggle('is-visible', isVisible);
      document.body.classList.toggle('product-ritual-sticky-atc-visible', isVisible);
    }

    function syncDisabledState() {
      stickyButton.disabled = mainButton.disabled;
    }

    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled) {
        return;
      }

      mainButton.click();
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(syncDisabledState);
      observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    syncDisabledState();

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        if (!MOBILE_QUERY.matches) {
          setStickyVisible(false);
          return;
        }

        setStickyVisible(!entries[0].isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -72px 0px',
      }
    );

    function bindObserver() {
      visibilityObserver.disconnect();

      if (MOBILE_QUERY.matches) {
        setStickyVisible(false);
        visibilityObserver.observe(formBlock);
      } else {
        setStickyVisible(false);
      }
    }

    bindObserver();

    if (typeof MOBILE_QUERY.addEventListener === 'function') {
      MOBILE_QUERY.addEventListener('change', bindObserver);
    } else if (typeof MOBILE_QUERY.addListener === 'function') {
      MOBILE_QUERY.addListener(bindObserver);
    }
  }

  function ensureFlipbookIframeLoaded() {
    var modal = document.getElementById('flipbookModal');
    if (!modal) return;

    var iframe = modal.querySelector('iframe[data-flipbook-src]');
    if (!iframe || iframe.dataset.flipbookLoaded) return;

    iframe.src = iframe.getAttribute('data-flipbook-src');
    iframe.dataset.flipbookLoaded = 'true';
  }

  function openFlipbookModal() {
    ensureFlipbookIframeLoaded();
    var modal = document.getElementById('flipbookModal');
    if (modal) {
      modal.style.display = 'block';
      document.body.classList.add('flipbook-modal-open');
    }
  }

  function closeFlipbookModal() {
    var modal = document.getElementById('flipbookModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('flipbook-modal-open');
    }
  }

  function initProductRitualFlipbook() {
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('.open-flipbook');
        if (!trigger) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        openFlipbookModal();
      },
      true
    );

    var closeBtn = document.getElementById('closeFlipbook');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeFlipbookModal);
    }

    window.addEventListener('click', function (event) {
      var modal = document.getElementById('flipbookModal');
      if (event.target === modal) {
        closeFlipbookModal();
      }
    });

    if (typeof jQuery === 'undefined') {
      return;
    }

    jQuery('.product-ritual .js-product-gallery').each(function () {
      var $gallery = jQuery(this);
      $gallery.on('staticClick.flickity', function (_event, _pointer, cellElement) {
        if (cellElement && cellElement.querySelector('.open-flipbook')) {
          openFlipbookModal();
        }
      });
    });
  }

  var STOQ_BADGE_STYLE_ID = 'yt-stoq-badge-overrides';

  function injectStoqBadgeOverrides() {
    if (document.getElementById(STOQ_BADGE_STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STOQ_BADGE_STYLE_ID;
    style.textContent =
      '.product-ritual .product-ritual-price-row{align-items:center!important}'
      + '.product-ritual .product-ritual-price-row .modal_price,.product-ritual .product__details--product-page .product-block--price .modal_price{display:flex!important;align-items:center!important;padding-bottom:0!important;gap:.4rem .65rem}'
      + '.product-ritual .product-ritual-price-row .modal_price>.price-ui,.product-ritual .product__details--product-page .product-block--price .modal_price>.price-ui{display:inline-flex!important;align-items:center!important}'
      + '.product-ritual .restock-rocket-preorder-badge,.product-ritual .preorder-badge-product,.product-ritual [class*="restock-rocket-preorder-badge"]{display:inline-flex!important;align-items:center!important;align-self:center!important;vertical-align:middle!important;font-size:.5625rem!important;line-height:1.2!important;padding:.15rem .4rem!important;border-radius:999px!important;height:auto!important;margin:0!important;letter-spacing:.04em;text-transform:uppercase}';

    document.body.appendChild(style);
  }

  function initStoqPreorderBadge() {
    if (!document.body.classList.contains('product-ritual')) {
      return;
    }

    function apply() {
      injectStoqBadgeOverrides();
    }

    document.addEventListener('stoq:loaded', apply);
    document.addEventListener('stoq:inventory-data-loaded', apply);
    apply();

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    var priceRoot =
      document.querySelector('.product-ritual .product-ritual-price-row')
      || document.querySelector('.product-ritual .modal_price');

    if (!priceRoot) {
      return;
    }

    var observer = new MutationObserver(apply);
    observer.observe(priceRoot, { childList: true, subtree: true });
  }

  function initJudgemeLazyPreviewBadge() {
    var mounts = document.querySelectorAll('[data-yt-judgeme-badge-lazy]');
    if (!mounts.length) {
      return;
    }

    function loadBadge(mount) {
      if (mount.dataset.ytJudgemeBadgeLoaded === 'true') {
        return;
      }
      mount.dataset.ytJudgemeBadgeLoaded = 'true';
      var template = mount.querySelector('.yt-judgeme-badge-template');
      if (!template) {
        return;
      }
      mount.appendChild(template.content.cloneNode(true));
      mount.classList.add('is-loaded');
    }

    function loadAllBadges() {
      mounts.forEach(loadBadge);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAllBadges, { timeout: 2500 });
    } else {
      window.addEventListener('load', function () {
        setTimeout(loadAllBadges, 1500);
      });
    }
  }

  function ensureFancyboxCss() {
    if (document.getElementById('yt-fancybox-css')) {
      return;
    }
    var href = document.body.getAttribute('data-yt-fancybox-css');
    if (!href) {
      return;
    }
    var link = document.createElement('link');
    link.id = 'yt-fancybox-css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function initDeferredFancyboxCss() {
    if (!document.body.getAttribute('data-yt-fancybox-css')) {
      return;
    }

    document.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('.lightbox, [data-fancybox]')) {
          ensureFancyboxCss();
        }
      },
      true
    );

    if ('requestIdleCallback' in window) {
      requestIdleCallback(ensureFancyboxCss, { timeout: 5000 });
    }
  }

  function initDeferredViewItem() {
    var node = document.getElementById('yt-product-view-item-data');
    if (!node) {
      return;
    }

    function pushViewItem() {
      try {
        var payload = JSON.parse(node.textContent);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: payload,
        });
      } catch (_error) {
        /* ignore malformed JSON */
      }
    }

    window.addEventListener('load', pushViewItem);
  }

  function getJudgemeLazyMount() {
    return document.querySelector('[data-yt-judgeme-lazy]');
  }

  function loadJudgemeReviewWidget() {
    var mount = getJudgemeLazyMount();
    if (!mount || mount.dataset.ytJudgemeLoaded === 'true') {
      return mount;
    }

    var template = mount.querySelector('.yt-judgeme-lazy-template');
    if (!template) {
      return mount;
    }

    mount.dataset.ytJudgemeLoaded = 'true';
    mount.appendChild(template.content.cloneNode(true));
    var host = mount.closest('.product-app--judgeme-lazy');
    if (host) {
      host.classList.add('is-loaded');
    }

    var widget = mount.querySelector('.jdgm-widget[data-entry-point][data-widget="review"]');
    if (!widget || !window.jdgm) {
      return mount;
    }

    var jdgm = window.jdgm;
    var entryPoint = widget.dataset.entryPoint;
    var entryKey = widget.dataset.entryKey;
    var cdnBase = jdgm.CDN_BASE_URL;

    if (!cdnBase || !entryPoint) {
      return mount;
    }

    var scriptSrc = cdnBase + entryPoint;
    if (document.querySelector('script[src="' + scriptSrc + '"]')) {
      return mount;
    }

    function appendModuleScript() {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = scriptSrc;
      document.head.appendChild(script);
    }

    fetch(cdnBase + 'manifest.json?v=' + Date.now())
      .then(function (response) {
        return response.json();
      })
      .then(function (manifest) {
        var entry = manifest[entryKey];
        if (entry && entry.css) {
          entry.css.forEach(function (cssPath) {
            var href = cdnBase + cssPath;
            if (!document.querySelector('link[href="' + href + '"]')) {
              var link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = href;
              document.head.appendChild(link);
            }
          });
        }
        appendModuleScript();
      })
      .catch(function () {
        appendModuleScript();
      });

    return mount;
  }

  function scrollToJudgemeReviews() {
    var mount = loadJudgemeReviewWidget();
    var target =
      document.getElementById('judgeme_product_reviews') ||
      document.getElementById('yt-judgeme-reviews') ||
      (mount && mount.querySelector('.jdgm-widget[data-widget="review"]')) ||
      mount;

    if (!target || typeof target.scrollIntoView !== 'function') {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initJudgemeLazyReviewWidget() {
    var mount = getJudgemeLazyMount();
    if (!mount || mount.dataset.ytJudgemeLoaded === 'true') {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      loadJudgemeReviewWidget();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          loadJudgemeReviewWidget();
        }
      },
      { rootMargin: '320px 0px', threshold: 0 }
    );

    observer.observe(mount);
  }

  function initJudgemeStarsClick() {
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest(
          '.jdgm-preview-badge, .jdgm-prev-badge, [data-yt-judgeme-badge-lazy], .yt-judgeme-stars-link'
        );
        if (!trigger) {
          return;
        }

        var mounts = document.querySelectorAll('[data-yt-judgeme-badge-lazy]');
        mounts.forEach(function (badgeMount) {
          if (badgeMount.dataset.ytJudgemeBadgeLoaded === 'true') {
            return;
          }
          var template = badgeMount.querySelector('.yt-judgeme-badge-template');
          if (!template) {
            return;
          }
          badgeMount.dataset.ytJudgemeBadgeLoaded = 'true';
          badgeMount.appendChild(template.content.cloneNode(true));
          badgeMount.classList.add('is-loaded');
        });

        scrollToJudgemeReviews();
      },
      true
    );
  }

  function initGalleryFlickityFallback() {
    window.setTimeout(function () {
      document.querySelectorAll('.product-ritual .product_gallery:not(.flickity-enabled)').forEach(function (gallery) {
        gallery.classList.add('yt-gallery-no-flickity');
        gallery.style.opacity = '1';
      });
    }, 5000);
  }

  function initProductRitual() {
    initProductRitualStickyAtc();
    initProductRitualFlipbook();
    initStoqPreorderBadge();
    initDeferredFancyboxCss();
    initDeferredViewItem();
    initJudgemeLazyPreviewBadge();
    initJudgemeLazyReviewWidget();
    initJudgemeStarsClick();
    initGalleryFlickityFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRitual);
  } else {
    initProductRitual();
  }
})();
